/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Checkout_Trust_Line1Inputs */

const vi_sitesettings_checkout_trust_line1 = /** @type {(inputs: Sitesettings_Checkout_Trust_Line1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng tin cậy`)
};

/**

* @param {Sitesettings_Checkout_Trust_Line1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_checkout_trust_line1 = /** @type {((inputs?: Sitesettings_Checkout_Trust_Line1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Checkout_Trust_Line1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_checkout_trust_line1(inputs)
});
export { sitesettings_checkout_trust_line1 as "siteSettings_checkout_trust_line" }